// extracted by mini-css-extract-plugin
export var text = "_93-0";